/**
 * @generated SignedSource<<a2dee8a43ef7172b8604502309f9b263>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeeSheetBasedFiltersModal_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleSwitcher_session">;
  readonly " $fragmentType": "TeeSheetBasedFiltersModal_session";
};
export type TeeSheetBasedFiltersModal_session$key = {
  readonly " $data"?: TeeSheetBasedFiltersModal_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeeSheetBasedFiltersModal_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeeSheetBasedFiltersModal_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ScheduleSwitcher_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "8934acf9a1d1018416d6d0060415db35";

export default node;
